import {
  default as Router,
  Route
} from "vue-router";
import Enumerable from "linq";
import { LoggerFactory } from "../../../utilities/logger";
import { instanceOfIPrefetchable } from "../../../utilities";
import { ExtendedRouteConfig } from "./ExtendedRouteConfig";

export class ExtendedRouter extends Router {
  constructor(private readonly routes: ExtendedRouteConfig[]) {
    super({
      base: process.env.ASSET_PATH,
      mode: "history", // historyにしないと、browserの戻るボタンを押した時にフックが上手く機能せず画面遷移してしまう...
    });
    this.addRoutes(this.routes);
  }

  prefetch(to: Route, from: Route): void {
    const config = Enumerable.from(this.routes)
      .firstOrDefault(r => r.path === to.path);
    if (!config || !config.prefetch) {
      return;
    }
    try {
      config.prefetch(this.executePrefetch, to, from);
    } catch (e) {
      LoggerFactory.getLogger().error(e);
    }
  }

  async executePrefetch<TInstance, TResult>(instance: TInstance, fetch: (i: TInstance) => Promise<TResult>): Promise<TResult> {
    if (!instanceOfIPrefetchable(instance)) {
      throw new Error("prefetchできません.");
    }
    instance.shouldPrefetch = true;
    return fetch(instance);
  }
}
